import type {ImageModel} from '@/types/content';

export const TIPS_CARD_SIZES = {
    BIG: 'big',
    SMALL: 'small',
} as const;

export type TipsCardSize = (typeof TIPS_CARD_SIZES)[keyof typeof TIPS_CARD_SIZES];

export interface GuideCardProps {
    title?: string;
    imageMedia?: ImageModel[];
    size?: TipsCardSize;
    borderless?: boolean;
    className?: string;
    onClick?: () => void;
}
